module.exports = __webpack_public_path__ + "static/media/zimbabwe-flag-round-small.30cf10eb.jpg";